export default {
  en: {
    title: "Queues Main Configurations",
    tab_skills: "Queues",
    tab_periods: "Periods",
    tab_schedule: "Schedules",
    tab_wait_class: "Wait Class",
    tab_acw: "ACW",
    skills: {
      title: "System Queues",
      skill: "queue {name}",
    },
    periods: {
      title: "Manage Rest Periods",
      new_period: "New Period",
      periods: "Periods",
      period_field: "Enter New Period",
      add_period_btn: "Add New Period",
      clear_btn: " Clear",
      minute: "{n} minute | {n} minutes",
      delete_btn: "Delete",
      period_missing: "enter a period",
      period_minimum: "period must be a number over 2 minutes",
      period_exist: "period exist",
    },
    schedules: {
      title: "Shedueles Management",
      create_btn: "Create Schedule",
      schedules_list: "Schedules List",
      empty_schedules: "No Schedules Added Yet....",
      edit_schedule_btn: "Edit",
      offwork_audio_set_btn: "off work",
      delete_schedule_btn: "Delete",
      progress_schedule_process: "Processing Schedule....",
      progress_schedule_delete: "Deleting Schedule....",
      progress_schedule_offwork: "Processing Schedule off work message....",
      progress_schedule_offwork_remove:
        "Removing Schedule off work message....",
      skill_schedule: {
        create_title: "Schedule Create",
        modify_title: "Schedule Modify",
        name_label: "schedule name",
        hours_label: "Hours",
        days_enable_check: "Set Days Schedule",
        range_label: "Range",
        months_enable_check: "Set Months Schedule",
        monthDay_enable_check: "Set Month Days Schedule",
        is_off_time_schedule: "OFF time",
        schedule_confirm_btn: "Confirm",
        schedule_manage_btn: "Management",
        schedule_name_required: "schedule name is required",
        schedule_name_exist: "name already exist",
        schedule_name_exist_set: "name exists in diffrent schedule!",
      },
      skill_offwork: {
        title: "OFF WORK Audio Message",
        remove_btn: "Remove",
        file_label: "offtime audio",
        confirm_btn: "Confirm",
        close_offwork: "Close",
        err_message:
          "audio File must be selected of type wav/gsm/mp3 with maximum size of 6 mb",
        max_size_message: "audio size should be less than 6 MB!",
      },
    },
    wait_class: {
      title: "Manage Queue Wait Classes",
      create_title: "Create Class",
      name_label: "class name",
      file_label: "class audio",
      create_btn: "Create",
      clear_btn: "Clear",
      list_title: "Classes List",
      empty_list: "No Classes added Yet....",
      file_change_label: "change class audio",
      update_btn: "Update",
      delete_btn: "Delete",
      progress_set_class: "Setting up wait class....",
      progress_delete_class: "Deleting wait class....",
      class_file_required: "class file is required",
      class_file_invalid: "Invalid file",
      class_file_max_size: "maximum file size should be 6MB",
      class_name_exist: "name already exist",
    },
    acw: {
      title: "After Call Work Settings",
      enable: "Enabled",
      disable: "Disabled",
      skills_title: "Queues",
      timeout_title: "ACW Timeout",
      timeout_duration_label: "timer length after call",
      after_work_title: "After Work Must Types",
      after_work_reasons: "Call Reasons",
      after_work_crm: "CRM",
      update_acw_btn: "Save",
      error_miss_timeout: "timeout duration is required",
      error_no_updates: "no changes to be updated",
      init_acw: "initializing ACW....",
      acw_update_progress: "updating ACW....",
      enable_acw_label: "Enable After Call Work",
      after_work_hint: "Give agents time to wrap up after each call.",
      after_work_types_hint: "Tasks an agent must complete before the next call",
      queues_hint: "ACW applies to agents in the selected queues",
      queues_placeholder: "Select queues",
      error_no_queue: "Select at least one queue",
    },
    audio: {
      title: "Queue Wait/ Domain Welcome Management",
    },
    manage_skill: {
      title: "Manage Queue {queue}",
      tab_info: "Info",
      tab_settings: "Settings",
      tab_schedule: "Wait/Schedule",
      tab_agents: "Agents",
      info: {
        title: "Basic Queue Info",
        info_name: "Queue",
        info_agents: "Total Agents",
        info_calls: "Total Calls",
        info_limit_agent: "Agents/Limit",
        info_limit_rest: "Resting/Limit",
        info_forwarding: "Call Forwarding",
        info_schedule: "Schedule",
        schedule_enable: "Enabled",
        schedule_disabled: "Disabled",
        schedule_hours: "HOURS",
        schedule_days: "Week Days",
        schedule_months: "Months",
        schedule_days_month: "Days in Month",
        short_code: "Short Code",
        actions: "Actions",
        search: "Search queue",
        empty: "No queues found",
      },
      settings: {
        title: "Update Queue Main Settings",
        limit: "Limit",
        agents: "{n} Agent | {n} Agents",
        rest_check: "set the maximum concurrent resting agents",
        busy_check: "set the maximum concurrent busy agents",
        limit_placeholder: "Enter new limit",
        limit_btn: "Set Limit",
        clear_btn: "Clear",
        limit_missing: "must enter a limit first",
        limit_minimum: "max rest limit has to be minumum of 1",
        limit_invalid: "limit value is invalid",
        limit_exist: "please enter a diffrent limit value",
      },
      schedule_wait_class: {
        title: "Manage Queue Schedules& Wait Class audios",
        schedule_title: "Schedule",
        change_schedule_btn: "Change Schedule",
        select_btn: "Select",
        remove_btn: "remove",
        link_to_schedules: "Schedules Management",
        close_view: "Close",
        class_title: "Wait Class",
        change_class_btn: "Change Class",
        emptye_class_list: "No Classes added Yet....",
        link_to_classes: "Wait Class Management",
        progress_init: "initializing queue schedule & wait settings....",
        progress_schedule_set: "Setting Schedule.......",
        progress_class_set: "Setting Wait Class.......",
      },
      agents: {
        title: "Modifying Queue Agents",
        change_agents_btn: "Add/Remove Agents in queue",
        select_title: "Select Agents",
        update_btn: "Update Queue",
        link_to_user_mange: "manage",
        progress: "Updating queue Agent List........",
        delete_btn: "Delete",
      },
      config: {
        title: "Configure Queue",
        configure_btn: "Configure",
        limits_title: "Concurrency Limits",
        limits_hint: "Cap how many agents can rest or be busy at once.",
        rest_limit: "Max resting agents",
        busy_limit: "Max busy agents",
        limits_of: "Out of {count} agents in this queue",
        last_agent_title: "Last Agent Routing",
        last_agent_hint:
          "Send a returning caller back to the agent who last served them in this queue.",
        members_title: "Members",
        members_hint:
          "Click an agent to move them between the two lists.",
        members_available: "Available Agents",
        members_in_queue: "In This Queue",
        members_search: "Search agents",
        members_none_available: "No agents to add",
        members_none_selected: "No agents in this queue yet",
        save: "Save",
        saving: "Loading queue configuration...",
        limits_saved: "Limits updated",
        last_agent_saved: "Last agent routing updated",
      },
    },
  },
  ar: {
    title: "إعدادات المجموعات الأساسية",
    tab_skills: "المجموعات",
    tab_periods: "فترات الراحة",
    tab_schedule: "جداول العمل",
    tab_wait_class: "نغمة الإنتظار",
    tab_acw: "ACW",
    skills: {
      title: "قائمة المجموعات",
      skill: "مجموعة {name}",
    },
    periods: {
      title: "اعدادات فترات الراحة للموظفين",
      new_period: "فترة جديدة",
      periods: "الفترات",
      period_field: "إدخال فترة جديدة",
      add_period_btn: "إضافة فترة جديدة",
      clear_btn: "إعادة ضبط",
      minute:
        "لا دقائق | دقيقة واحدة | دقيقتان | {n} دقائق | {n} دقيقة | {n} دقيقة",
      delete_btn: "مسح",
      period_missing: "إدخال قيمة",
      period_minimum: "أقل قيمة هي دقيقتان",
      period_exist: "القيمة موجودة مسبقا",
    },
    schedules: {
      title: "تعديل/إضافة جداول العمل",
      create_btn: "إنشاء جدول عمل",
      schedules_list: "قائمة جداول الأعمال",
      empty_schedules: "لم يتم إضافة جداول بعد......",
      edit_schedule_btn: "تعديل",
      offwork_audio_set_btn: "خارج الدوام",
      delete_schedule_btn: "إزالة",
      progress_schedule_process: "معالجة جدول العمل......",
      progress_schedule_delete: "جاري إزالة الجدول......",
      progress_schedule_offwork:
        "جاري معالجة الرسالة لخارج مواعيد العمل.......",
      progress_schedule_offwork_remove: "جاري إزالة الرسالة.......",
      skill_schedule: {
        create_title: "إنشاء جدول مواعيد",
        modify_title: "تعديل جدول مواعيد",
        name_label: "اسم جدول مواعيد",
        hours_label: "الساعات",
        days_enable_check: "تحديد أيام عمل",
        range_label: "نطاق",
        months_enable_check: "تحديد شهور عمل",
        monthDay_enable_check: "تحديد أيام خلال الشهر",
        is_off_time_schedule: "تحديد الإعدادات كخارج مواعيد العمل",
        schedule_confirm_btn: "تأكيد",
        schedule_manage_btn: "إدارة",
        schedule_name_required: "اسم الجدول اجباري",
        schedule_name_exist: "الاسم موجود مسبقا",
        schedule_name_exist_set: "الاسم موجود في جدول آخر",
      },
      skill_offwork: {
        title: "الرسالة الصوتية لخارج مواعيد العمل",
        remove_btn: "إزالة",
        file_label: "ملف خارج المواعيد",
        confirm_btn: "تأكيد",
        close_offwork: "غلق",
        err_message:
          "نوع الملف الصوتي يجب ان يكون من نوع wav/gsm/mp3 وبحجم لا يتخطى 6MG",
        max_size_message: "الحجم الأقصى للملف هو 6MB",
      },
    },
    wait_class: {
      title: "إدارة نغمة/رسائل الإنتظار المجموعات",
      create_title: "إنشاء نوع نغمة انتظار",
      name_label: "اسم النوع",
      file_label: "الملف الصوتي",
      create_btn: "إنشاء",
      clear_btn: "مسح",
      list_title: "قائمة أنواع ملفات الانتظار",
      empty_list: "لم يتم اضافة نوع بعد.......",
      file_change_label: "تغيير الملف الصوتي",
      update_btn: "تعديل",
      delete_btn: "إزالة",
      progress_set_class: "معالجة الملف الصوتي......",
      progress_delete_class: "جاري المسح.......",
      class_file_required: "الملف الصوتي اجباري",
      class_file_invalid: "ملف خاطئ",
      class_file_max_size: "الحجم الأقصى للملف هو 6MB",
      class_name_exist: "الاسم موجود مسبقا",
    },
    acw: {
      title: "إعدادات تسجيل الأعمال المصاحبة لبعد المكالمة (ACW)",
      enable: "مفعّل",
      disable: "موقوف",
      skills_title: "المجموعات",
      timeout_title: "الفترة المحدودة",
      timeout_duration_label: "مدة الفترة الزمنية لبعد المكالمة",
      after_work_title: "أنواع الأعمال الملزمة للتفعبل",
      after_work_reasons: "سبب المكالمة",
      after_work_crm: "بيانات المتصل",
      update_acw_btn: "حفظ",
      error_miss_timeout: "الفترة الزمنية غير محددة",
      error_no_updates: "لا يوجد تغيير ليتم التحديث",
      init_acw: "تهيئة الACW....",
      acw_update_progress: "جاري تحديث ال(ACW)....",
      enable_acw_label: "تفعيل العمل بعد المكالمة",
      after_work_hint: "امنح الموظفين وقتًا لإنهاء أعمال المكالمة بعد انتهائها.",
      after_work_types_hint: "المهام التي يجب على الموظف إكمالها قبل المكالمة التالية",
      queues_hint: "يُطبّق العمل بعد المكالمة على موظفي المجموعات المحددة",
      queues_placeholder: "اختر المجموعات",
      error_no_queue: "اختر مجموعة واحدة على الأقل",
    },
    audio: {
      title: "تعديل/إضافة الوسائط الصوتية",
    },
    manage_skill: {
      title: "إعدادات المجموعة {skill}",
      tab_info: "البيانات",
      tab_settings: "الإعدادات",
      tab_schedule: "جدول العمل",
      tab_agents: "الموظفين",
      info: {
        title: "بيانات المجموعة الأساسية",
        info_name: "المجموعة",
        info_agents: "عدد الموظفين",
        info_calls: "عدد المكالمات",
        info_limit_agent: "الحد الأقصى للموظفين",
        info_limit_rest: "الحد الأقصى خلال الراحة",
        info_forwarding: "تحويل المكالمات",
        info_schedule: "جدول العمل",
        schedule_enable: "مفعّل",
        schedule_disabled: "موقوف",
        schedule_hours: "الساعات",
        schedule_days: "أيام الأسبوع",
        schedule_months: "الشهور",
        schedule_days_month: "أيام الشهر",
        short_code: "الرمز المختصر",
        actions: "الإجراءات",
        search: "ابحث عن مجموعة",
        empty: "لا توجد مجموعات",
      },
      settings: {
        title: "تعديل الأعدادات العامة للمجموعة",
        limit: "الحد الأقصى",
        agents:
          "{n} موظف | موظف واحدة | موظفان | {n} موظفين | {n} موظف | {n} موظف",
        rest_check: "تحديد الحد الأقصى للراحة في نفس الوقت",
        busy_check: "تحديد الحد الأقصى للإنشغال في نفس الوقت",
        limit_placeholder: "إدخال حد جديد",
        limit_btn: "تحديث",
        clear_btn: "مسح",
        limit_missing: "قيمة الحد الأقصى مطلوبة",
        limit_minimum: "أقل قيمة للحد الأقصى 2",
        limit_invalid: "قيمة الحد الأقصى خاطئة",
        limit_exist: "هذه القيمة الحالية للحد الأقصى",
      },
      schedule_wait_class: {
        title: "تعديل اعدادات جدول عمل المجموعة",
        schedule_title: "مواعيد العمل",
        change_schedule_btn: "تغيير جدول مواعيد العمل",
        select_btn: "اختيار",
        remove_btn: "إزالة",
        link_to_schedules: "إلى إدارة جداول العمل",
        close_view: "غلق",
        class_title: "نوع نغمة الانتظار",
        change_class_btn: "تغيير النوع",
        emptye_class_list: "لم يتم اضافة نوع بعد!",
        link_to_classes: "إلى إدارة نغمات الانتظار",
        progress_init: "جاري المعالجة............",
        progress_schedule_set: "جاري ضبط الجدول......",
        progress_class_set: "جاري ضبط نغمة الانتظار",
      },
      agents: {
        title: "موظفين المجموعة",
        change_agents_btn: "إضافة/حذف موظفين من المجموعة",
        select_title: "اختيار الموظفين",
        update_btn: "تعديل المجموعة",
        link_to_user_mange: "إدارة",
        progress: "جاري تعديل المجموعة.........",
        delete_btn: "حذف",
      },
      config: {
        title: "إعدادات المجموعة",
        configure_btn: "إعداد",
        limits_title: "حدود التزامن",
        limits_hint: "حدد عدد الموظفين المسموح لهم بالراحة أو الانشغال في آنٍ واحد.",
        rest_limit: "أقصى عدد للموظفين خلال الراحة",
        busy_limit: "أقصى عدد للموظفين المنشغلين",
        limits_of: "من أصل {count} موظفًا في هذه المجموعة",
        last_agent_title: "التوجيه لآخر موظف",
        last_agent_hint:
          "توجيه العميل عند معاودة الاتصال إلى آخر موظف خدمه في هذه المجموعة.",
        members_title: "الموظفون",
        members_hint: "اضغط على الموظف لنقله بين القائمتين.",
        members_available: "الموظفون المتاحون",
        members_in_queue: "ضمن هذه المجموعة",
        members_search: "ابحث عن موظف",
        members_none_available: "لا يوجد موظفون للإضافة",
        members_none_selected: "لا يوجد موظفون في هذه المجموعة بعد",
        save: "حفظ",
        saving: "جاري تحميل إعدادات المجموعة...",
        limits_saved: "تم تحديث الحدود",
        last_agent_saved: "تم تحديث التوجيه لآخر موظف",
      },
    },
  },
};
